import { servicosSaudeFeriadoApi } from "@/api/ServicosSaudeFeriadoApi";
import FeriadoFiltro from "@/models/cadastros/saude/FeriadoFiltro";
import FeriadoModel from "@/models/cadastros/saude/FeriadoModel";

class FeriadoService {
  obterFeriados(filtro: FeriadoFiltro) {
    let page = 0;
    if (filtro.options?.page) {
      page = filtro.options?.page - 1;
    }

    const filtroDTO = {
      tipo: filtro.tipo,
      page: page,
      dataInicial: filtro.dataInicial,
      dataFinal: filtro.dataFinal,
      size: filtro.options?.itemsPerPage,
      sort: "dataFeriado",
    };
    return servicosSaudeFeriadoApi.pesquisarFeriados(filtroDTO);
  }

  obterFeriadoPorId(idFeriado: Number) {
    return servicosSaudeFeriadoApi.obterFeriadoPorId(idFeriado);
  }

  deletar(idFeriado: Number) {
    return servicosSaudeFeriadoApi.deletarFeriado(idFeriado);
  }

  salvar(feriado: FeriadoModel) {
    let cidade = feriado.cidade;
    let estado = feriado.estado;

    if (feriado.tipo?.name == "NACIONAL") {
      cidade = undefined;
      estado = undefined;
    } else if (feriado.tipo?.name == "ESTADUAL") {
      cidade = undefined;
    }

    const feriadoDTO = {
      cidadeId: cidade?.id,
      dataFeriado: feriado.dataFeriado,
      descricao: feriado.descricao,
      estado: estado?.sigla,
      tipo: feriado.tipo?.name,
    };
    return servicosSaudeFeriadoApi.salvarFeriado(feriadoDTO);
  }

  atualizar(feriado: FeriadoModel, idFeriado: Number) {
    let cidade = feriado.cidade;
    let estado = feriado.estado;

    if (feriado.tipo?.name == "NACIONAL") {
      cidade = undefined;
      estado = undefined;
    }

    if (feriado.tipo?.name == "ESTADUAL") {
      cidade = undefined;
    }

    const feriadoDTO = {
      cidadeId: cidade?.id,
      dataFeriado: feriado.dataFeriado,
      descricao: feriado.descricao,
      estado: estado?.sigla,
      tipo: feriado.tipo?.name,
    };
    return servicosSaudeFeriadoApi.atualizarFeriado(idFeriado, feriadoDTO);
  }
}

export const feriadoService = new FeriadoService();
